import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import Bannerfrom from "../components/bannerfrom";
import { Link } from "gatsby";

function Banner(props) {
  return (
    <div className="services_location_banner">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={7} xxl={7} className="my-auto">
            <div className="banenr_content">
              <div className="example" data-text="Boston">
                <h1>Mobile App Development Company In Boston</h1>
              </div>
              <p className="main_para">
                On the lookout for a top-tier mobile app development company in
                Boston? Your search ends here with TekRevol! We excel at
                creating groundbreaking mobile apps that provide outstanding
                user experiences. Our team of experts is committed to
                transforming your app concept into a tangible product. We
                possess the skills to guide you through the ever-changing
                digital realm with precision and proficiency. As a prominent
                mobile app development company in Boston, we are driven by our
                enthusiasm for designing apps that not only meet but also
                surpass industry benchmarks.
              </p>
              <Link
                to="/contact"
                className="border_btn dark_btn"
                aria-label="TekRevol Contact"
              >
                Let’s Get Started
              </Link>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={5} xxl={5} className="my-auto">
            <Bannerfrom />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
